"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tipos;
(function (Tipos) {
    Tipos["ETIQUETA_DOBLE"] = "ETIQUETA_DOBLE";
    Tipos["ETIQUETA_SIMPLE"] = "ETIQUETA_SIMPLE";
    Tipos["ETIQUETA_UNICA"] = "ETIQUETA_UNICA";
    Tipos["ATRIBUTO"] = "ATRIBUTO";
    Tipos["VALOR"] = "VALOR";
})(Tipos = exports.Tipos || (exports.Tipos = {}));
